/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { getCurrentQtr } from '../../../../SharedModules/utilities/utilities';
import * as ActionTypes from './actionTypes';

const currentQtr = getCurrentQtr().join('Q');
const initialState = {
  searchResult: [],
  rebateProgram: '',
  rebateProgramList: [],
  selectedPlanType: '',
  isLoading: false,
  planType: [],
  rebateProgramValue: '',
  rebateProgramNameValue: '',
  errors: [],
  fromDateValue: currentQtr,
  detailObj: {
    rebateProgramValue: '',
    fromDateValue: currentQtr,
    searchResult: [],
    rebateProgramList: [],
    rebateProgrameName: '',
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: action.payload };
    // case ActionTypes.GET_REBATE_PROGRAM_TERMINATED_LABELER:
    //   return { ...state, rebateProgramList: action.payload };

    case ActionTypes.SET_TERMINATED_LABELER_REPORT:
      let detailObj = {
        ...state.detailObj,
        searchResult: action.payload,
      };
      return { ...state, searchResult: action.payload, detailObj };

    case ActionTypes.SET_SELECTED_INPUT:
      return { ...state, ...action.payload };
    case ActionTypes.REFRESH_TERMINATED_LABELER:
      return {
        ...initialState,
        detailObj: state.detailObj,
      };
    case ActionTypes.REFRESH_TERMINATED_LABELER_DISPALY:
      return {
        ...initialState,
        detailObj: state.detailObj,
      };

    case ActionTypes.IS_LOADING:
      return { ...state, isLoading: action.isLoading };

    default:
      return state;
  }
};

export default reducer;
